// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1e7OB","left":"InfoRow_left__3lZ4s"};